<template>
  <div>
    <a-tabs :activeKey="params.statuses" @change="handeChange">
      <template v-for="tab in tabs">
        <a-tab-pane :key="tab.value" :tab="tab.label"></a-tab-pane>
      </template>
    </a-tabs>
    <a-row :gutter="30" style="padding-top:30px;">
      <a-col span="7" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">电话</a-col>
          <a-col span="18">
            <a-input v-model="params.user_mobile"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="7" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">姓名</a-col>
          <a-col span="18">
            <a-input v-model="params.user_name"></a-input>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-between">
      <a-col>
        <a-button type="primary" style="margin-right:12px;padding:0 30px;" @click="getData()">筛选</a-button>
        <a-button style="margin-right:12px;" @click="resetParams">清空筛选条件</a-button>
        <span>共找到 {{ total }} 条信息</span>
      </a-col>
    </a-row>
    <a-list
      itemLayout="vertical"
      :bordered="false"
      style="margin-top:40px"
      @change="getData"
      :loading="loading"
    >
      <template v-for="item in dataSource">
        <a-list-item :key="item.id">
          <a-row type="flex" align="middle" justify="space-between">
            <a-col>
              <a-row type="flex" align="middle" :gutter="30">
                <a-col>
                  <a-avatar
                    style="width:62px;height:62px;"
                    :src="item.job.company.logo_url || img"
                    size="large"
                    shape="square"
                  ></a-avatar>
                </a-col>
                <a-col>
                  <h3>
                    <b style="display:inline-block;min-width:350px;">{{ item.job.name }}</b>
                    <b
                      style="color: red; "
                    >{{ item.job.hunter_salary_min }}-{{ item.job.hunter_salary_max }}万</b>
                  </h3>
                  <div>
                    <span>{{ item.job.city_name }}</span>
                    <a-divider type="vertical"></a-divider>
                    <span>招聘{{ item.job.quantity }}人</span>
                    <a-divider type="vertical"></a-divider>
                    <span>{{ item.job.experience_name }}经验</span>
                    <a-divider type="vertical"></a-divider>
                    <span>{{ item.job.education_name }}</span>
                  </div>
                  <p>
                    <span>
                      {{
                      item.job.company.first_category_name ? item.job.company.first_category_name : '' + "-" + item.job.company.second_category_name ? item.job.company.second_category_name : ''
                      }}
                    </span>
                    <a-divider type="vertical"></a-divider>
                    <span>{{ item.job.company.name }}</span>
                  </p>
                </a-col>
              </a-row>
            </a-col>
            <a-col style="padding-left:40px;border-left:1px solid #ccc; min-width:400px;">
              <a-row type="flex" align="middle" :gutter="30">
                <a-col>
                  <a-avatar
                    style="width:66px;height:66px;line-height:66px;background:rgba(234,247,254);color:#8FD4FB;font-size:30px;"
                    size="large"
                  >{{ item.user_name[0] }}</a-avatar>
                </a-col>
                <a-col>
                  <h3>
                    <b>{{ item.user_name }}</b>
                    <span
                      style="color:#aaa;margin-left:18px; font-weight:400"
                    >{{ item.user_mobile }}</span>
                  </h3>
                  <div>
                    <span>{{ item.user_current_company_name }}</span>
                  </div>
                  <p>
                    <span>{{ item.user_city_name }}</span>
                    <a-divider type="vertical"></a-divider>
                    <span>{{ item.user_working_years }}年工作经验</span>
                    <a-divider type="vertical"></a-divider>
                    <span>{{ item.user_current_position }}</span>
                  </p>
                </a-col>
              </a-row>
            </a-col>
            <a-col style="padding-left:20px;border-left:1px solid #ccc;">
              <a-row
                type="flex"
                align="middle"
                justify="center"
                style="flex-direction: column;min-width:150px;"
              >
                <a-col style="margin-bottom:8px;">
                  <div style="border:1px solid #ccc;padding:4px 8px;border-radius:3px;">
                    <!-- <template v-if="item.status === 'created'"></template> -->
                    <a
                      @click.stop="$refs.markModal.show(item)"
                      v-if="
                        isGranted(
                          'clue_manager.clue_candidate.btn_list_candidate_add_remark'
                        )
                      "
                    >
                      <a-icon type="edit"></a-icon>
                    </a>
                    <a-divider
                      type="vertical"
                      style="background:#999;margin:0 10px"
                      v-if="
                        isGranted(
                          'clue_manager.clue_candidate.btn_list_candidate_add_remark'
                        )
                      "
                    ></a-divider>
                    <a @click.stop="showMarkDetail(item)">沟通结果</a>
                  </div>
                </a-col>
                <a-col style="margin-bottom:8px;">
                  <div style="border:1px solid #ccc;padding:4px 8px;border-radius:3px;">
                    <a-upload
                      v-if="
                        !item.resume_id > 0 &&
                          isGranted(
                            'clue_manager.clue_candidate.btn_list_upload_resume'
                          )
                      "
                      name="file"
                      :multiple="false"
                      :action="uploadUrl"
                      @change="handleUpload"
                      :data="{
                        token: $store.state.token,
                        clue_candidate_id: item.id
                      }"
                      :showUploadList="false"
                    >
                      <a>
                        <a-icon type="edit"></a-icon>
                      </a>
                    </a-upload>
                    <a-upload
                      v-if="
                        item.resume_id == 0 &&
                          isGranted(
                            'clue_manager.clue_candidate.btn_list_upload_resume'
                          )
                      "
                      name="file"
                      :multiple="false"
                      :action="uploadUrl2"
                      @change="handleUpload"
                      :data="{
                        token: $store.state.token,
                        resume_id: item.resume_id
                      }"
                      :showUploadList="false"
                    >
                      <a>
                        <a-icon type="edit"></a-icon>
                      </a>
                    </a-upload>
                    <a-divider
                      v-if="
                        item.resume_id == 0 && isGranted(
                          'clue_manager.clue_candidate.btn_list_upload_resume'
                        )
                      "
                      type="vertical"
                      style="background:#999;margin:0 10px"
                    ></a-divider>
                    <a @click.stop="$refs.preview.show(item.attachment)">简历</a>
                  </div>
                </a-col>
                <a-col
                  v-if="
                    item.resume_id > 0 &&
                      isGranted('clue_manager.clue_candidate.btn_list_post')
                  "
                >
                  <a-button @click="todoOrder(item)">做单</a-button>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-list-item>
      </template>
    </a-list>
    <a-row type="flex" align="middle" justify="end" :style="{padding: '30px 0'}">
      <Pagination ref="pagination" :total="total" @change="getData"></Pagination>
    </a-row>
    <mark-modal ref="markModal" @check="checkStatus"></mark-modal>
    <mark-detail-modal ref="markDetailModal"></mark-detail-modal>
    <Recommend ref="recommend"></Recommend>
    <resume-preview-modal ref="preview"></resume-preview-modal>
  </div>
</template>
<script>
import moment from "moment";
import Api from "@/api";
import MarkModal from "./mark-modal";
import MarkDetailModal from "./mark-detail-modal";
import Recommend from "@/components/recomend";
import baseComponentVue from "@/components/base-component.vue";
import ResumePreviewModal from "@/components/resume-preview-modal";
import Pagination from "@/components/Pagination";
export default {
  name: "RelationshipCash",
  extends: baseComponentVue,
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASEURL + "/resume/clueGenerateResume",
      uploadUrl2: process.env.VUE_APP_BASEURL + "/resume/attachment/create",
      tabs: Object.freeze([
        { label: "全部变现", value: "" },
        { label: "新推变现", value: "CREATE" },
        { label: "已获取简历", value: "SUCCESS" },
        { label: "待进一步沟通", value: "WAIT_COMMUNICATE" },
        { label: "未获取简历", value: "FAILED" }
      ]),
      loading: false,
      dataSource: [],
      columns: [],
      total: 0,
      pagination: null,
      params: {
        statuses: ""
      },
      img: require("@/assets/defaultLogo.png")
    };
  },
  components: {
    MarkModal,
    MarkDetailModal,
    Recommend,
    Pagination,
    ResumePreviewModal
  },
  computed: {},
  mounted() {
    this.resetParams();
    this.pagination = this.$refs.pagination;
    this.getData();
  },
  methods: {
    handeChange(val) {
      this.params.statuses = val;
      this.getData();
    },
    async getData(pagination) {
      this.loading = true;
      let params = {
        ...this.params,
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };
      if (!pagination) {
        this.pagination.current = 1;
        params.page = 1;
        this.pagination.pageSize = 10;
        params.limit = 10;
      } else {
        params.page = pagination.current;
        params.limit = pagination.pageSize;
      }

      let response = await Api.cash.getRelationList(params);
      this.loading = false;
      this.total = +response.total;
      this.dataSource = response.list;
    },
    resetParams() {
      let params = {
        user_mobile: "",
        user_name: ""
      };
      this.params = { statuses: this.params.statuses, ...params };
    },
    handleUpload(e) {
      const status = e.file.status;
      console.log(status, e);
      if (status === "done") {
        this.$message.info("上传完成");
        this.getData();
      }
    },
    showMarkDetail(item) {
      console.log(item);
      if (item.remark) {
        this.$refs.markDetailModal.show(item);
      } else {
        this.$message.info("暂无沟通结果");
      }
    },
    async todoOrder(item) {
      let res= await Api.post.checkPost({
        resume_id: item.resume_id,
        job_id: item.job.id
      });
      if (res.result == 1) {
        let { resume } = await Api.position.resumeDetails({
          resume_id: item.resume_id
        });
        let that = this;
        if (res.same_resume_name == 1) {
            this.$confirm({
            content: '系统检测到该职位已有猎头推荐同名候选人，疑似重复推荐！',
            okText: '继续推荐',
            cancelText: '取消',
            onOk() {
               that.$refs.recommend.show(resume, item.job.id, item.job.name);
            },
            onCancel() { return;},
            });
        }else{
            that.$refs.recommend.show(resume, item.job.id, item.job.name);
        }
      } else {
        this.$message.info("该人脉已经投递，请尝试其他人脉数据做单");
      }
    },
    async checkStatus(item, remark, status) {
      await Api.cash.checkRelationStatus({
        status,
        remark,
        id: item.id
      });
      this.$refs.markModal.close();
      this.getData();
    }
  }
};
</script>

<style scoped lang="scss"></style>
